import { servicesWithdraws } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { withdraws as typesWithdraws, network } from 'types';

const useAddWithdraw = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesWithdraws.TAddWithdraw
    >({
        mutationFn: servicesWithdraws.add,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useAddWithdraw;
